import React from 'react'
import * as Displays from 'support/displays'
import { ExecuteOperationOnPipe, ModelProxy, ModelWithForm, useModelKey } from '@morningtrain/react-resources'
import { Fieldset } from 'layouts/index'
import * as Fields from 'support/fields'
import { useEnvValue } from '@morningtrain/react-helpers'
import { ButtonWrap, SpaceBetween } from 'ui/layouts'
import { SquareButton } from 'ui/buttons'
import * as Icons from 'ui/icons'
import { NestedAsyncPipeline } from '@morningtrain/react-pipelines'

function EditableSupplierCategory () {
  const [isEditing, setIsEditing] = React.useState(false)

  const modelKey = useModelKey()
  const key = ['globals.inventory.supplier_categories', modelKey].join('.')
  const [category, setCategory] = useEnvValue(key, null)

  const updateActive = (event) => {
    const isActive = event.target.checked

    setCategory(isActive ? [] : null)
  }

  return (
    <ModelProxy resourceName='inventory.category'>
      <SpaceBetween>
        <input type='checkbox' onChange={updateActive} checked={category !== null} />
        <div className='flex-grow px-4'>
          <Displays.Text name='name' />
        </div>
        <ButtonWrap className=''>
          {!isEditing ? (
            <SquareButton onClick={() => setIsEditing(true)} color='btn-lightgray'>
              <Icons.Pencil className='w-4' />
            </SquareButton>
          ) : null}
        </ButtonWrap>
      </SpaceBetween>
      {!isEditing ? null : (
        <ModelWithForm resourceName='inventory.category' id={modelKey}>
          <ExecuteOperationOnPipe operationName='index' operationContext={{ context: 'smartview' }} />
          <ExecuteOperationOnPipe operationName='index' />

          <Fieldset innerClassName='py-4'>
            <Fields.Input name='name_translations.da' label='Navn (da)' />
            <Fields.Input name='name_translations.en' label='Navn (en)' />
          </Fieldset>
          <ButtonWrap>
            <SquareButton onClick={() => setIsEditing(false)} color='btn-white'>
              <Icons.Decline className='w-3' />
            </SquareButton>
            <SquareButton color='btn-primary' type='submit'>
              <Icons.Checkmark className='w-3' />
            </SquareButton>
          </ButtonWrap>
        </ModelWithForm>
      )}
    </ModelProxy>
  )
}

export default EditableSupplierCategory
